export default function SkillCard({ title, items }) {
  return (
    <div className="p-5 sm:p-6 bg-surface-card rounded-xl shadow-lg border border-surface-border transition-colors hover:border-accent-cyan/40">
      <h3 className="text-lg font-semibold mb-3 sm:text-xl text-accent-cyan">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => (
          <span
            key={item}
            className="px-2.5 py-1 text-xs sm:text-sm rounded-md bg-surface border border-surface-border text-gray-300"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
